module.exports = __webpack_public_path__ + "static/media/triangle_up.1107bd60.svg";